// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AcceptInvitationData,
  AcceptInvitationResponses,
  AddAttachmentData,
  AddAttachmentResponses,
  AddData,
  AddMemberData,
  AddMemberResponses,
  AddNoteData,
  AddNoteResponses,
  AddResponses,
  AdminCountClaimRequestsData,
  AdminCountClaimRequestsResponses,
  AdminListClaimRequestsData,
  AdminListClaimRequestsResponses,
  AppInfoData,
  AppInfoResponses,
  ApplyData,
  ApplyPushGrantDefaultsData,
  ApplyPushGrantDefaultsResponses,
  ApplyResponses,
  ApproveClaimRequestData,
  ApproveClaimRequestResponses,
  AssignAdminData,
  AssignAdminResponses,
  BulkUpdateData,
  BulkUpdateResponses,
  CallbackData,
  CancelClaimRequestData,
  CancelClaimRequestResponses,
  CancelInviteData,
  CancelInviteResponses,
  CancelScheduledPlanChangeData,
  CancelScheduledPlanChangeResponses,
  CapabilitiesData,
  CapabilitiesResponses,
  ChangeSubscriptionPlanData,
  ChangeSubscriptionPlanResponses,
  CheckUsernameAvailability2Data,
  CheckUsernameAvailability2Responses,
  CheckUsernameAvailabilityData,
  CheckUsernameAvailabilityResponses,
  ClaimRequestData,
  ClaimRequestManualData,
  ClaimRequestManualResponses,
  ClaimRequestResponses,
  ClaimVerifyData,
  ClaimVerifyResponses,
  ClearPasswordData,
  ClearPasswordResponses,
  ClearSkipData,
  ClearSkipResponses,
  ConfirmAccountDeletionData,
  ConfirmAccountDeletionResponses,
  ConfirmNewEmailData,
  ConfirmNewEmailResponses,
  ContactViaData,
  ContactViaResponses,
  CountClaimRequestsData,
  CountClaimRequestsResponses,
  Create10Data,
  Create10Responses,
  Create2Data,
  Create2Responses,
  Create3Data,
  Create3Responses,
  Create4Data,
  Create4Responses,
  Create5Data,
  Create5Responses,
  Create6Data,
  Create6Responses,
  Create7Data,
  Create7Responses,
  Create8Data,
  Create8Responses,
  Create9Data,
  Create9Responses,
  CreateAdminData,
  CreateAdminResponses,
  CreateBulkReplyDraftsData,
  CreateBulkReplyDraftsResponses,
  CreateCheckoutSessionData,
  CreateCheckoutSessionResponses,
  CreateData,
  CreateFormTemplateData,
  CreateFormTemplateResponses,
  CreateInviteData,
  CreateInviteResponses,
  CreateMailTemplateData,
  CreateMailTemplateResponses,
  CreatePortalSessionData,
  CreatePortalSessionResponses,
  CreateReplyDraftData,
  CreateReplyDraftResponses,
  CreateResponses,
  CreateWithMailData,
  CreateWithMailResponses,
  DeleteByHashAdminData,
  DeleteByHashAdminResponses,
  DeleteData,
  DeleteFormTemplateData,
  DeleteFormTemplateResponses,
  DeleteMailTemplateData,
  DeleteMailTemplateResponses,
  DeleteReplyData,
  DeleteReplyResponses,
  DeleteResponses,
  DiscardChangesData,
  DiscardChangesResponses,
  DisconnectData,
  DisconnectResponses,
  DownloadContactVcfData,
  DownloadContactVcfResponses,
  DownloadWalletPassData,
  DownloadWalletPassResponses,
  ExchangeBusinessCardData,
  ExchangeBusinessCardResponses,
  FindAll2Data,
  FindAll2Responses,
  FindAll3Data,
  FindAll3Responses,
  FindAll4Data,
  FindAll4Responses,
  FindAll5Data,
  FindAll5Responses,
  FindAll6Data,
  FindAll6Responses,
  FindAll7Data,
  FindAll7Responses,
  FindAll8Data,
  FindAll8Responses,
  FindAll9Data,
  FindAll9Responses,
  FindAllAdminData,
  FindAllAdminResponses,
  FindAllData,
  FindAllResponses,
  FindBillbeeAddressByIdData,
  FindBillbeeAddressByIdResponses,
  FindBillbeeOrderByIdData,
  FindBillbeeOrderByIdResponses,
  FindBillbeePackingStationOrdersData,
  FindBillbeePackingStationOrdersResponses,
  FindBillbeeStockItemsData,
  FindBillbeeStockItemsResponses,
  FindById2Data,
  FindById2Responses,
  FindByIdData,
  FindByIdResponses,
  FindByUserAndWorkspaceData,
  FindByUserAndWorkspaceResponses,
  FindByWorkspaceAndUsernameData,
  FindByWorkspaceAndUsernameResponses,
  FindByWorkspaceIdAndUserIdData,
  FindByWorkspaceIdAndUserIdResponses,
  FindData,
  FindFacetsAdminData,
  FindFacetsAdminResponses,
  FindFacetsData,
  FindFacetsResponses,
  FindLeadsData,
  FindLeadsResponses,
  FindOne2Data,
  FindOne2Responses,
  FindOne3Data,
  FindOne3Responses,
  FindOne4Data,
  FindOne4Responses,
  FindOne5Data,
  FindOne5Responses,
  FindOne6Data,
  FindOne6Responses,
  FindOne7Data,
  FindOne7Responses,
  FindOne8Data,
  FindOne8Responses,
  FindOneAdminData,
  FindOneAdminResponses,
  FindOneByHashData,
  FindOneByHashOnlyData,
  FindOneByHashOnlyResponses,
  FindOneByHashResponses,
  FindOneData,
  FindOneResponses,
  FindRecentLiveScansAdminData,
  FindRecentLiveScansAdminResponses,
  FindRecentScansData,
  FindRecentScansResponses,
  FindResponses,
  FindScansAdminData,
  FindScansAdminResponses,
  FindScansData,
  FindScansResponses,
  FindStatsAdminData,
  FindStatsAdminResponses,
  FindTopUsedData,
  FindTopUsedResponses,
  FindUsageTimeSeriesData,
  FindUsageTimeSeriesResponses,
  GetAnalyticsData,
  GetAnalyticsResponses,
  GetBillingGrantContextData,
  GetBillingGrantContextResponses,
  GetBoardData,
  GetBoardResponses,
  GetBulkReplyDraftBatchData,
  GetBulkReplyDraftBatchResponses,
  GetByTokenData,
  GetByTokenResponses,
  GetChannelLocationsData,
  GetChannelLocationsResponses,
  GetCompetitorsData,
  GetCompetitorsResponses,
  GetConnectUrlData,
  GetConnectUrlResponses,
  GetData,
  GetDriversData,
  GetDriversResponses,
  GetEntitlementsData,
  GetEntitlementsResponses,
  GetEntryData,
  GetEntryResponses,
  GetEventAnalyticsData,
  GetEventAnalyticsResponses,
  GetFormTemplateData,
  GetFormTemplateResponses,
  GetGooglePlaceByIdData,
  GetGooglePlaceByIdResponses,
  GetIntercomIdentityData,
  GetIntercomIdentityResponses,
  GetInviteData,
  GetInviteResponses,
  GetMailTemplateData,
  GetMailTemplateResponses,
  GetMemberValuesData,
  GetMemberValuesResponses,
  GetMyMembershipsData,
  GetMyMembershipsResponses,
  GetMyPermissionsData,
  GetMyPermissionsResponses,
  GetNotificationsOpsSummaryData,
  GetNotificationsOpsSummaryResponses,
  GetOpsBillingData,
  GetOpsBillingResponses,
  GetOpsGrowthData,
  GetOpsGrowthResponses,
  GetOpsHealthData,
  GetOpsHealthResponses,
  GetOpsIntegrationsData,
  GetOpsIntegrationsResponses,
  GetOpsJobFailuresData,
  GetOpsJobFailuresResponses,
  GetOpsJobFailureTrendData,
  GetOpsJobFailureTrendResponses,
  GetOpsJobsData,
  GetOpsJobsResponses,
  GetOpsMetricsSeriesData,
  GetOpsMetricsSeriesResponses,
  GetOpsOverviewData,
  GetOpsOverviewResponses,
  GetOverviewData,
  GetOverviewResponses,
  GetPendingInvitationsData,
  GetPendingInvitationsResponses,
  GetPresetsData,
  GetPresetsResponses,
  GetProductFunnelData,
  GetProductFunnelResponses,
  GetPublicConfigData,
  GetPublicConfigResponses,
  GetReplyData,
  GetReplyPromptTemplatesData,
  GetReplyPromptTemplatesResponses,
  GetReplyResponses,
  GetResponses,
  GetRevisionData,
  GetRevisionResponses,
  GetStatsData,
  GetStatsResponses,
  GetStatusData,
  GetStatusResponses,
  GetSummaryData,
  GetSummaryResponses,
  GetTeamStatusData,
  GetTeamStatusResponses,
  GetUsageData,
  GetUsageResponses,
  GetUsernameProposals2Data,
  GetUsernameProposals2Responses,
  GetUsernameProposalsData,
  GetUsernameProposalsResponses,
  GetUserPreferencesData,
  GetUserPreferencesResponses,
  GetWalletCardStatusData,
  GetWalletCardStatusResponses,
  InspectByHashAdminData,
  InspectByHashAdminResponses,
  InviteUserData,
  InviteUserResponses,
  LinkData,
  LinkResponses,
  List2Data,
  List2Responses,
  ListClaimRequestsData,
  ListClaimRequestsResponses,
  ListContactsData,
  ListContactsResponses,
  ListData,
  ListDeletionsData,
  ListDeletionsResponses,
  ListEntriesData,
  ListEntriesResponses,
  ListFormTemplatesData,
  ListFormTemplatesResponses,
  ListInboxData,
  ListInboxResponses,
  ListInvitesData,
  ListInvitesResponses,
  ListLocationsData,
  ListLocationsResponses,
  ListMailTemplatesData,
  ListMailTemplatesResponses,
  ListMembersData,
  ListMembersResponses,
  ListProductEventsAdminData,
  ListProductEventsAdminResponses,
  ListProductEventsData,
  ListProductEventsResponses,
  ListReportsData,
  ListReportsResponses,
  ListResponses,
  ListReviewsData,
  ListReviewsResponses,
  ListRevisionsData,
  ListRevisionsResponses,
  ListTypesData,
  ListTypesResponses,
  ListWorkspaceReviewsData,
  ListWorkspaceReviewsResponses,
  LoginData,
  LoginResponses,
  LoginWithPasswordData,
  LoginWithPasswordResponses,
  LogoutData,
  LogoutResponses,
  LookupData,
  LookupResponses,
  MarkAllReadData,
  MarkAllReadResponses,
  MarkGeneratedAdminData,
  MarkGeneratedAdminResponses,
  MarkProgrammedAdminData,
  MarkProgrammedAdminResponses,
  MarkReadData,
  MarkReadResponses,
  MarkReviewsSeenData,
  MarkReviewsSeenResponses,
  MeData,
  MeResponses,
  MoveAdminData,
  MoveAdminResponses,
  NearbyData,
  NearbyResponses,
  PackProductsData,
  PackProductsResponses,
  PatchEntryData,
  PatchEntryResponses,
  PreviewPlanChangeData,
  PreviewPlanChangeResponses,
  ProductReviewCtaGetData,
  ProductReviewCtaGetResponses,
  ProductReviewCtaPostData,
  ProductReviewCtaPostResponses,
  PublishData,
  PublishReplyDraftData,
  PublishReplyDraftResponses,
  PublishResponses,
  RecomputeOpsMetricsDayData,
  RecomputeOpsMetricsDayResponses,
  RecordDirectViewData,
  RecordDirectViewResponses,
  RefreshData,
  RefreshResponses,
  RegisterBatchAdminData,
  RegisterBatchAdminResponses,
  RegisterData,
  RegisterDeviceData,
  RegisterDeviceResponses,
  RegisterGoodsReceiptAdminData,
  RegisterGoodsReceiptAdminResponses,
  RegisterResponses,
  RejectClaimRequestData,
  RejectClaimRequestResponses,
  RejectInvitationData,
  RejectInvitationResponses,
  Remove10Data,
  Remove10Responses,
  Remove11Data,
  Remove11Responses,
  Remove12Data,
  Remove12Responses,
  Remove2Data,
  Remove2Responses,
  Remove3Data,
  Remove3Responses,
  Remove4Data,
  Remove4Responses,
  Remove5Data,
  Remove5Responses,
  Remove6Data,
  Remove6Responses,
  Remove7Data,
  Remove7Responses,
  Remove8Data,
  Remove8Responses,
  Remove9Data,
  Remove9Responses,
  RemoveAdminData,
  RemoveAdminResponses,
  RemoveAttachmentData,
  RemoveAttachmentResponses,
  RemoveData,
  RemoveMemberData,
  RemoveMemberResponses,
  RemoveNoteData,
  RemoveNoteResponses,
  RemovePhoneData,
  RemovePhoneResponses,
  RemoveResponses,
  ReorderAttachmentsData,
  ReorderAttachmentsResponses,
  RequestEmailChangeData,
  RequestEmailChangeResponses,
  RequestPhoneVerificationData,
  RequestPhoneVerificationResponses,
  ResendClaimRequestData,
  ResendClaimRequestResponses,
  ResendInviteRecipientData,
  ResendInviteRecipientResponses,
  ResolveByPublicHashData,
  ResolveByPublicHashResponses,
  ResolveLoginData,
  ResolveLoginResponses,
  ResolveProductHashData,
  ResolveProductHashResponses,
  ResolveRosterData,
  ResolveRosterResponses,
  ResolveTargetUrlData,
  ResolveTargetUrlResponses,
  RestoreRevisionData,
  RestoreRevisionResponses,
  ResyncTemplateData,
  ResyncTemplateResponses,
  RevealSetupContactAdminData,
  RevealSetupContactAdminResponses,
  ReviewCtaGetData,
  ReviewCtaGetResponses,
  ReviewCtaPostData,
  ReviewCtaPostResponses,
  RevokeBillingGrantData,
  RevokeBillingGrantResponses,
  RevokeDeviceData,
  RevokeDeviceResponses,
  RunIntegrityData,
  RunIntegrityResponses,
  ScanBusinessCardData,
  ScanBusinessCardResponses,
  SearchAdminLocationsData,
  SearchAdminLocationsResponses,
  SearchAdminUsersData,
  SearchAdminUsersResponses,
  SearchAdminWorkspacesData,
  SearchAdminWorkspacesResponses,
  SearchBillbeeOrdersData,
  SearchBillbeeOrdersResponses,
  SearchGooglePlacesData,
  SearchGooglePlacesResponses,
  SearchNotificationDeliveriesData,
  SearchNotificationDeliveriesResponses,
  SearchProductsByOrderData,
  SearchProductsByOrderResponses,
  SendInviteData,
  SendInviteResponses,
  SendPreviewMailData,
  SendPreviewMailResponses,
  SetMemberValuesData,
  SetMemberValuesResponses,
  SetPasswordData,
  SetPasswordResponses,
  SetupProductData,
  SetupProductResponses,
  ShipBillbeeOrderData,
  ShipBillbeeOrderResponses,
  SkipData,
  SkipResponses,
  StartImpersonationData,
  StartImpersonationResponses,
  StopImpersonationData,
  StopImpersonationResponses,
  StreamData,
  StreamLiveScansAdminData,
  StreamLiveScansAdminResponses,
  StreamResponses,
  SubmitData,
  SubmitLeadFormData,
  SubmitLeadFormResponses,
  SubmitProductData,
  SubmitProductResponses,
  SubmitResponses,
  SuggestReplyData,
  SuggestReplyPreviewData,
  SuggestReplyPreviewResponses,
  SuggestReplyResponses,
  SummarizeEventsByMetadataFieldData,
  SummarizeEventsByMetadataFieldResponses,
  SummaryData,
  SummaryResponses,
  UnlinkData,
  UnlinkResponses,
  UnreadCountData,
  UnreadCountResponses,
  UnsubscribeData,
  UnsubscribeResponses,
  Update10Data,
  Update10Responses,
  Update11Data,
  Update11Responses,
  Update12Data,
  Update12Responses,
  Update2Data,
  Update2Responses,
  Update3Data,
  Update3Responses,
  Update4Data,
  Update4Responses,
  Update5Data,
  Update5Responses,
  Update6Data,
  Update6Responses,
  Update7Data,
  Update7Responses,
  Update8Data,
  Update8Responses,
  Update9Data,
  Update9Responses,
  UpdateAdminData,
  UpdateAdminErrors,
  UpdateAdminResponses,
  UpdateBillbeeAddressByIdData,
  UpdateBillbeeAddressByIdResponses,
  UpdateBillbeeStockBulkData,
  UpdateBillbeeStockBulkResponses,
  UpdateBillbeeStockData,
  UpdateBillbeeStockResponses,
  UpdateData,
  UpdateFormTemplateData,
  UpdateFormTemplateResponses,
  UpdateInviteData,
  UpdateInviteResponses,
  UpdateMailTemplateData,
  UpdateMailTemplateResponses,
  UpdateNoteData,
  UpdateNoteResponses,
  UpdateResponses,
  UpdateRoleData,
  UpdateRoleResponses,
  UpdateRosterData,
  UpdateRosterResponses,
  UpdateUserPreferencesData,
  UpdateUserPreferencesResponses,
  UploadFileData,
  UploadFileResponses,
  UpsertBillingGrantData,
  UpsertBillingGrantResponses,
  VerifyAndDeleteResetCodeData,
  VerifyAndDeleteResetCodeResponses,
  VerifyMagicLinkData,
  VerifyMagicLinkResponses,
  VerifyPhoneData,
  VerifyPhoneResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AdminOpsApi {
  /**
   * Betrieb overview tiles (platform admin, not impersonating)
   */
  public static getOpsOverview<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsOverviewData, ThrowOnError>,
  ): RequestResult<GetOpsOverviewResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsOverviewResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/overview',
      ...options,
    });
  }

  /**
   * Re-run the daily snapshot of one closed UTC day (idempotent; current-state domains only for yesterday)
   */
  public static recomputeOpsMetricsDay<ThrowOnError extends boolean = true>(
    options: Options<RecomputeOpsMetricsDayData, ThrowOnError>,
  ): RequestResult<RecomputeOpsMetricsDayResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RecomputeOpsMetricsDayResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/metrics/recompute',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Daily snapshot rows of one domain (platform admin)
   */
  public static getOpsMetricsSeries<ThrowOnError extends boolean = true>(
    options: Options<GetOpsMetricsSeriesData, ThrowOnError>,
  ): RequestResult<GetOpsMetricsSeriesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetOpsMetricsSeriesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/metrics/{domain}',
      ...options,
    });
  }

  /**
   * Dependency latencies, Redis memory, release and migration status of the answering API task (platform admin)
   */
  public static getOpsHealth<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsHealthData, ThrowOnError>,
  ): RequestResult<GetOpsHealthResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsHealthResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/health',
      ...options,
    });
  }

  /**
   * Delivery health per channel and source (24 h / 7 d), failing types, skipped reasons, invalid push tokens
   */
  public static getNotificationsOpsSummary<ThrowOnError extends boolean = true>(
    options?: Options<GetNotificationsOpsSummaryData, ThrowOnError>,
  ): RequestResult<GetNotificationsOpsSummaryResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetNotificationsOpsSummaryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/notifications',
      ...options,
    });
  }

  /**
   * Support lookup of ledger rows by workspace, user or recipient (hashed server-side; masked rows only)
   */
  public static searchNotificationDeliveries<
    ThrowOnError extends boolean = true,
  >(
    options: Options<SearchNotificationDeliveriesData, ThrowOnError>,
  ): RequestResult<
    SearchNotificationDeliveriesResponses,
    unknown,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      SearchNotificationDeliveriesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/notifications/deliveries/search',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Queue counts and platform schedulers (platform admin)
   */
  public static getOpsJobs<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsJobsData, ThrowOnError>,
  ): RequestResult<GetOpsJobsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsJobsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/jobs',
      ...options,
    });
  }

  /**
   * Terminal job failures, newest first (platform admin)
   */
  public static getOpsJobFailures<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsJobFailuresData, ThrowOnError>,
  ): RequestResult<GetOpsJobFailuresResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsJobFailuresResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/job-failures',
      ...options,
    });
  }

  /**
   * Terminal job failures per UTC day and queue (platform admin)
   */
  public static getOpsJobFailureTrend<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsJobFailureTrendData, ThrowOnError>,
  ): RequestResult<GetOpsJobFailureTrendResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsJobFailureTrendResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/job-failures/trend',
      ...options,
    });
  }

  /**
   * List-price MRR, subscriptions, movement, failed payments and grants (platform admin, not impersonating)
   */
  public static getOpsBilling<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsBillingData, ThrowOnError>,
  ): RequestResult<GetOpsBillingResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsBillingResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/billing',
      ...options,
    });
  }

  /**
   * Growth KPIs for today / 7 / 30 days (platform admin, cached 5 min)
   */
  public static getOpsGrowth<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsGrowthData, ThrowOnError>,
  ): RequestResult<GetOpsGrowthResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsGrowthResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/growth',
      ...options,
    });
  }

  /**
   * Review sync freshness, integration job failures and OpenAI usage (platform admin, cached 60 s)
   */
  public static getOpsIntegrations<ThrowOnError extends boolean = true>(
    options?: Options<GetOpsIntegrationsData, ThrowOnError>,
  ): RequestResult<GetOpsIntegrationsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetOpsIntegrationsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/ops/integrations',
      ...options,
    });
  }
}

export class AdminDataLifecycleApi {
  /**
   * Queue an integrity sweep. Repair applies registry policies; keep dryRun until a report was reviewed.
   */
  public static runIntegrity<ThrowOnError extends boolean = true>(
    options: Options<RunIntegrityData, ThrowOnError>,
  ): RequestResult<RunIntegrityResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RunIntegrityResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/data-lifecycle/integrity-runs',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static listReports<ThrowOnError extends boolean = true>(
    options?: Options<ListReportsData, ThrowOnError>,
  ): RequestResult<ListReportsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      ListReportsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/data-lifecycle/integrity-reports',
      ...options,
    });
  }

  public static listDeletions<ThrowOnError extends boolean = true>(
    options?: Options<ListDeletionsData, ThrowOnError>,
  ): RequestResult<ListDeletionsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      ListDeletionsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/data-lifecycle/deletions',
      ...options,
    });
  }
}

export class UsersApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options?: Options<FindAllData, ThrowOnError>,
  ): RequestResult<FindAllResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindAllResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<CreateData, ThrowOnError>,
  ): RequestResult<CreateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<RemoveData, ThrowOnError>,
  ): RequestResult<RemoveResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RemoveResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{id}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOneData, ThrowOnError>,
  ): RequestResult<FindOneResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOneResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{id}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<UpdateData, ThrowOnError>,
  ): RequestResult<UpdateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static clearPassword<ThrowOnError extends boolean = true>(
    options: Options<ClearPasswordData, ThrowOnError>,
  ): RequestResult<ClearPasswordResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      ClearPasswordResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{id}/password',
      ...options,
    });
  }

  public static setPassword<ThrowOnError extends boolean = true>(
    options: Options<SetPasswordData, ThrowOnError>,
  ): RequestResult<SetPasswordResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SetPasswordResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{id}/password',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class UsersPublicApi {
  public static getUsernameProposals<ThrowOnError extends boolean = true>(
    options: Options<GetUsernameProposalsData, ThrowOnError>,
  ): RequestResult<GetUsernameProposalsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      GetUsernameProposalsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/users-public/username/proposals',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static checkUsernameAvailability<ThrowOnError extends boolean = true>(
    options: Options<CheckUsernameAvailabilityData, ThrowOnError>,
  ): RequestResult<CheckUsernameAvailabilityResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      CheckUsernameAvailabilityResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/users-public/username/{username}/available',
      ...options,
    });
  }
}

export class AdminUsersApi {
  /**
   * Search users across all workspaces (platform admin)
   *
   * With `workspaceId`: only its members (`q` optional, then the first `limit` members by e-mail).
   */
  public static searchAdminUsers<ThrowOnError extends boolean = true>(
    options?: Options<SearchAdminUsersData, ThrowOnError>,
  ): RequestResult<SearchAdminUsersResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      SearchAdminUsersResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/users/search',
      ...options,
    });
  }
}

export class FilesApi {
  public static uploadFile<ThrowOnError extends boolean = true>(
    options: Options<UploadFileData, ThrowOnError>,
  ): RequestResult<UploadFileResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      UploadFileResponses,
      unknown,
      ThrowOnError
    >({
      ...formDataBodySerializer,
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/files/upload',
      ...options,
      headers: {
        'Content-Type': null,
        ...options.headers,
      },
    });
  }
}

export class AuthApi {
  public static login<ThrowOnError extends boolean = true>(
    options: Options<LoginData, ThrowOnError>,
  ): RequestResult<LoginResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      LoginResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/email/login',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static resolveLogin<ThrowOnError extends boolean = true>(
    options: Options<ResolveLoginData, ThrowOnError>,
  ): RequestResult<ResolveLoginResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ResolveLoginResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/email/login/resolve',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static verifyMagicLink<ThrowOnError extends boolean = true>(
    options: Options<VerifyMagicLinkData, ThrowOnError>,
  ): RequestResult<VerifyMagicLinkResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      VerifyMagicLinkResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/email/login/verify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static loginWithPassword<ThrowOnError extends boolean = true>(
    options: Options<LoginWithPasswordData, ThrowOnError>,
  ): RequestResult<LoginWithPasswordResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      LoginWithPasswordResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/email/login/password',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getPublicConfig<ThrowOnError extends boolean = true>(
    options?: Options<GetPublicConfigData, ThrowOnError>,
  ): RequestResult<GetPublicConfigResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetPublicConfigResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/public-config',
      ...options,
    });
  }

  public static register<ThrowOnError extends boolean = true>(
    options: Options<RegisterData, ThrowOnError>,
  ): RequestResult<RegisterResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RegisterResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/auth/email/register',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static confirmNewEmail<ThrowOnError extends boolean = true>(
    options: Options<ConfirmNewEmailData, ThrowOnError>,
  ): RequestResult<ConfirmNewEmailResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ConfirmNewEmailResponses,
      unknown,
      ThrowOnError
    >({
      url: '/api/v1/auth/email/confirm/new',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static delete<ThrowOnError extends boolean = true>(
    options?: Options<DeleteData, ThrowOnError>,
  ): RequestResult<DeleteResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).delete<
      DeleteResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/me',
      ...options,
    });
  }

  public static me<ThrowOnError extends boolean = true>(
    options?: Options<MeData, ThrowOnError>,
  ): RequestResult<MeResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<MeResponses, unknown, ThrowOnError>({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/me',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update2Data, ThrowOnError>,
  ): RequestResult<Update2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/me',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getIntercomIdentity<ThrowOnError extends boolean = true>(
    options?: Options<GetIntercomIdentityData, ThrowOnError>,
  ): RequestResult<GetIntercomIdentityResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetIntercomIdentityResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/intercom-identity',
      ...options,
    });
  }

  public static refresh<ThrowOnError extends boolean = true>(
    options?: Options<RefreshData, ThrowOnError>,
  ): RequestResult<RefreshResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).post<
      RefreshResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/refresh',
      ...options,
    });
  }

  public static logout<ThrowOnError extends boolean = true>(
    options?: Options<LogoutData, ThrowOnError>,
  ): RequestResult<LogoutResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).post<
      LogoutResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/logout',
      ...options,
    });
  }

  public static requestEmailChange<ThrowOnError extends boolean = true>(
    options: Options<RequestEmailChangeData, ThrowOnError>,
  ): RequestResult<RequestEmailChangeResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RequestEmailChangeResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/email/change/request',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static requestPhoneVerification<ThrowOnError extends boolean = true>(
    options: Options<RequestPhoneVerificationData, ThrowOnError>,
  ): RequestResult<RequestPhoneVerificationResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RequestPhoneVerificationResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/phone/request-verification',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static verifyPhone<ThrowOnError extends boolean = true>(
    options: Options<VerifyPhoneData, ThrowOnError>,
  ): RequestResult<VerifyPhoneResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      VerifyPhoneResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/phone/verify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static removePhone<ThrowOnError extends boolean = true>(
    options?: Options<RemovePhoneData, ThrowOnError>,
  ): RequestResult<RemovePhoneResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).delete<
      RemovePhoneResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/phone',
      ...options,
    });
  }

  public static startImpersonation<ThrowOnError extends boolean = true>(
    options: Options<StartImpersonationData, ThrowOnError>,
  ): RequestResult<StartImpersonationResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      StartImpersonationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/impersonate',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static stopImpersonation<ThrowOnError extends boolean = true>(
    options?: Options<StopImpersonationData, ThrowOnError>,
  ): RequestResult<StopImpersonationResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).post<
      StopImpersonationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/auth/impersonate/stop',
      ...options,
    });
  }

  public static confirmAccountDeletion<ThrowOnError extends boolean = true>(
    options: Options<ConfirmAccountDeletionData, ThrowOnError>,
  ): RequestResult<ConfirmAccountDeletionResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ConfirmAccountDeletionResponses,
      unknown,
      ThrowOnError
    >({
      url: '/api/v1/auth/account/delete/confirm',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class NotificationsApi {
  public static capabilities<ThrowOnError extends boolean = true>(
    options?: Options<CapabilitiesData, ThrowOnError>,
  ): RequestResult<CapabilitiesResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      CapabilitiesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/notifications/capabilities',
      ...options,
    });
  }

  public static revokeDevice<ThrowOnError extends boolean = true>(
    options: Options<RevokeDeviceData, ThrowOnError>,
  ): RequestResult<RevokeDeviceResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RevokeDeviceResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/notifications/devices',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static registerDevice<ThrowOnError extends boolean = true>(
    options: Options<RegisterDeviceData, ThrowOnError>,
  ): RequestResult<RegisterDeviceResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RegisterDeviceResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/notifications/devices',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static listTypes<ThrowOnError extends boolean = true>(
    options?: Options<ListTypesData, ThrowOnError>,
  ): RequestResult<ListTypesResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      ListTypesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/notifications/types',
      ...options,
    });
  }

  public static listInbox<ThrowOnError extends boolean = true>(
    options: Options<ListInboxData, ThrowOnError>,
  ): RequestResult<ListInboxResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListInboxResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/notifications',
      ...options,
    });
  }

  public static unreadCount<ThrowOnError extends boolean = true>(
    options: Options<UnreadCountData, ThrowOnError>,
  ): RequestResult<UnreadCountResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      UnreadCountResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/notifications/unread-count',
      ...options,
    });
  }

  public static markRead<ThrowOnError extends boolean = true>(
    options: Options<MarkReadData, ThrowOnError>,
  ): RequestResult<MarkReadResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      MarkReadResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/notifications/{notificationId}/read',
      ...options,
    });
  }

  public static markAllRead<ThrowOnError extends boolean = true>(
    options: Options<MarkAllReadData, ThrowOnError>,
  ): RequestResult<MarkAllReadResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      MarkAllReadResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/notifications/mark-all-read',
      ...options,
    });
  }

  public static getUserPreferences<ThrowOnError extends boolean = true>(
    options: Options<GetUserPreferencesData, ThrowOnError>,
  ): RequestResult<GetUserPreferencesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetUserPreferencesResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/me/notification-preferences',
      ...options,
    });
  }

  public static updateUserPreferences<ThrowOnError extends boolean = true>(
    options: Options<UpdateUserPreferencesData, ThrowOnError>,
  ): RequestResult<UpdateUserPreferencesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateUserPreferencesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/me/notification-preferences',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static applyPushGrantDefaults<ThrowOnError extends boolean = true>(
    options: Options<ApplyPushGrantDefaultsData, ThrowOnError>,
  ): RequestResult<ApplyPushGrantDefaultsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ApplyPushGrantDefaultsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/me/push/grant-defaults',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class WorkspacesApi {
  public static getTeamStatus<ThrowOnError extends boolean = true>(
    options?: Options<GetTeamStatusData, ThrowOnError>,
  ): RequestResult<GetTeamStatusResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetTeamStatusResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}/team-status',
      ...options,
    });
  }

  public static getMyPermissions<ThrowOnError extends boolean = true>(
    options?: Options<GetMyPermissionsData, ThrowOnError>,
  ): RequestResult<GetMyPermissionsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetMyPermissionsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}/me/permissions',
      ...options,
    });
  }

  public static findAll<ThrowOnError extends boolean = true>(
    options?: Options<FindAll2Data, ThrowOnError>,
  ): RequestResult<FindAll2Responses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindAll2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create2Data, ThrowOnError>,
  ): RequestResult<Create2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getUsernameProposals<ThrowOnError extends boolean = true>(
    options: Options<GetUsernameProposals2Data, ThrowOnError>,
  ): RequestResult<GetUsernameProposals2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      GetUsernameProposals2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/username/proposals',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static checkUsernameAvailability<ThrowOnError extends boolean = true>(
    options: Options<CheckUsernameAvailability2Data, ThrowOnError>,
  ): RequestResult<CheckUsernameAvailability2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      CheckUsernameAvailability2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/username/{username}/available',
      ...options,
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove2Data, ThrowOnError>,
  ): RequestResult<Remove2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove2Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne2Data, ThrowOnError>,
  ): RequestResult<FindOne2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update3Data, ThrowOnError>,
  ): RequestResult<Update3Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update3Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static inviteUser<ThrowOnError extends boolean = true>(
    options: Options<InviteUserData, ThrowOnError>,
  ): RequestResult<InviteUserResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      InviteUserResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{id}/invite',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class WorkspaceInvitationsApi {
  /**
   * Get pending invitations for current user
   */
  public static getPendingInvitations<ThrowOnError extends boolean = true>(
    options?: Options<GetPendingInvitationsData, ThrowOnError>,
  ): RequestResult<GetPendingInvitationsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetPendingInvitationsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspace-invitations/pending',
      ...options,
    });
  }

  /**
   * Accept a workspace invitation
   */
  public static acceptInvitation<ThrowOnError extends boolean = true>(
    options: Options<AcceptInvitationData, ThrowOnError>,
  ): RequestResult<AcceptInvitationResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      AcceptInvitationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspace-invitations/{membershipId}/accept',
      ...options,
    });
  }

  /**
   * Reject a workspace invitation
   */
  public static rejectInvitation<ThrowOnError extends boolean = true>(
    options: Options<RejectInvitationData, ThrowOnError>,
  ): RequestResult<RejectInvitationResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RejectInvitationResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspace-invitations/{membershipId}/reject',
      ...options,
    });
  }
}

export class WorkspaceMembersApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll3Data, ThrowOnError>,
  ): RequestResult<FindAll3Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll3Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/members',
      ...options,
    });
  }

  public static lookup<ThrowOnError extends boolean = true>(
    options: Options<LookupData, ThrowOnError>,
  ): RequestResult<LookupResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      LookupResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/members/lookup',
      ...options,
    });
  }

  public static updateRole<ThrowOnError extends boolean = true>(
    options: Options<UpdateRoleData, ThrowOnError>,
  ): RequestResult<UpdateRoleResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateRoleResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/members/{memberId}/role',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove3Data, ThrowOnError>,
  ): RequestResult<Remove3Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove3Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/members/{memberId}',
      ...options,
    });
  }

  public static getMyMemberships<ThrowOnError extends boolean = true>(
    options?: Options<GetMyMembershipsData, ThrowOnError>,
  ): RequestResult<GetMyMembershipsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetMyMembershipsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspace-members/me/memberships',
      ...options,
    });
  }
}

export class EntitlementsApi {
  public static getEntitlements<ThrowOnError extends boolean = true>(
    options: Options<GetEntitlementsData, ThrowOnError>,
  ): RequestResult<GetEntitlementsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetEntitlementsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/entitlements',
      ...options,
    });
  }
}

export class WorkspaceRolesApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll4Data, ThrowOnError>,
  ): RequestResult<FindAll4Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll4Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/roles',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create3Data, ThrowOnError>,
  ): RequestResult<Create3Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create3Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/roles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove4Data, ThrowOnError>,
  ): RequestResult<Remove4Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove4Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/roles/{roleId}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update4Data, ThrowOnError>,
  ): RequestResult<Update4Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update4Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/roles/{roleId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class TeamsApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll5Data, ThrowOnError>,
  ): RequestResult<FindAll5Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll5Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create4Data, ThrowOnError>,
  ): RequestResult<Create4Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create4Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove5Data, ThrowOnError>,
  ): RequestResult<Remove5Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove5Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne3Data, ThrowOnError>,
  ): RequestResult<FindOne3Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne3Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update5Data, ThrowOnError>,
  ): RequestResult<Update5Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update5Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static listMembers<ThrowOnError extends boolean = true>(
    options: Options<ListMembersData, ThrowOnError>,
  ): RequestResult<ListMembersResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListMembersResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members',
      ...options,
    });
  }

  public static addMember<ThrowOnError extends boolean = true>(
    options: Options<AddMemberData, ThrowOnError>,
  ): RequestResult<AddMemberResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      AddMemberResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static removeMember<ThrowOnError extends boolean = true>(
    options: Options<RemoveMemberData, ThrowOnError>,
  ): RequestResult<RemoveMemberResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RemoveMemberResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members/{teamMemberId}',
      ...options,
    });
  }
}

export class ProfileTemplatesApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll6Data, ThrowOnError>,
  ): RequestResult<FindAll6Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll6Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create5Data, ThrowOnError>,
  ): RequestResult<Create5Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create5Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove6Data, ThrowOnError>,
  ): RequestResult<Remove6Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove6Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne4Data, ThrowOnError>,
  ): RequestResult<FindOne4Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne4Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update6Data, ThrowOnError>,
  ): RequestResult<Update6Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update6Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static publish<ThrowOnError extends boolean = true>(
    options: Options<PublishData, ThrowOnError>,
  ): RequestResult<PublishResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      PublishResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/publish',
      ...options,
    });
  }

  public static discardChanges<ThrowOnError extends boolean = true>(
    options: Options<DiscardChangesData, ThrowOnError>,
  ): RequestResult<DiscardChangesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      DiscardChangesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/discard-changes',
      ...options,
    });
  }

  public static listRevisions<ThrowOnError extends boolean = true>(
    options: Options<ListRevisionsData, ThrowOnError>,
  ): RequestResult<ListRevisionsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListRevisionsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions',
      ...options,
    });
  }

  public static getRevision<ThrowOnError extends boolean = true>(
    options: Options<GetRevisionData, ThrowOnError>,
  ): RequestResult<GetRevisionResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetRevisionResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions/{revision}',
      ...options,
    });
  }

  public static restoreRevision<ThrowOnError extends boolean = true>(
    options: Options<RestoreRevisionData, ThrowOnError>,
  ): RequestResult<RestoreRevisionResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RestoreRevisionResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions/{revision}/restore',
      ...options,
    });
  }

  public static getMemberValues<ThrowOnError extends boolean = true>(
    options: Options<GetMemberValuesData, ThrowOnError>,
  ): RequestResult<GetMemberValuesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetMemberValuesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/member-values',
      ...options,
    });
  }

  public static setMemberValues<ThrowOnError extends boolean = true>(
    options: Options<SetMemberValuesData, ThrowOnError>,
  ): RequestResult<SetMemberValuesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      SetMemberValuesResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/member-values',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static apply<ThrowOnError extends boolean = true>(
    options: Options<ApplyData, ThrowOnError>,
  ): RequestResult<ApplyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ApplyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/apply',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class BillingApi {
  public static createCheckoutSession<ThrowOnError extends boolean = true>(
    options: Options<CreateCheckoutSessionData, ThrowOnError>,
  ): RequestResult<CreateCheckoutSessionResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateCheckoutSessionResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/billing/checkout-session',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static previewPlanChange<ThrowOnError extends boolean = true>(
    options: Options<PreviewPlanChangeData, ThrowOnError>,
  ): RequestResult<PreviewPlanChangeResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      PreviewPlanChangeResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/billing/preview-plan-change',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static changeSubscriptionPlan<ThrowOnError extends boolean = true>(
    options: Options<ChangeSubscriptionPlanData, ThrowOnError>,
  ): RequestResult<ChangeSubscriptionPlanResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ChangeSubscriptionPlanResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/billing/change-plan',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static cancelScheduledPlanChange<ThrowOnError extends boolean = true>(
    options: Options<CancelScheduledPlanChangeData, ThrowOnError>,
  ): RequestResult<CancelScheduledPlanChangeResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CancelScheduledPlanChangeResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/billing/cancel-scheduled-change',
      ...options,
    });
  }

  public static createPortalSession<ThrowOnError extends boolean = true>(
    options: Options<CreatePortalSessionData, ThrowOnError>,
  ): RequestResult<CreatePortalSessionResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreatePortalSessionResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/billing/portal-session',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class AdminBillingGrantsApi {
  /**
   * Search workspaces for billing grant management (platform admin)
   */
  public static searchAdminWorkspaces<ThrowOnError extends boolean = true>(
    options: Options<SearchAdminWorkspacesData, ThrowOnError>,
  ): RequestResult<SearchAdminWorkspacesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      SearchAdminWorkspacesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/workspaces/search',
      ...options,
    });
  }

  /**
   * Get workspace usage context before applying a billing grant
   */
  public static getBillingGrantContext<ThrowOnError extends boolean = true>(
    options: Options<GetBillingGrantContextData, ThrowOnError>,
  ): RequestResult<GetBillingGrantContextResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetBillingGrantContextResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant/context',
      ...options,
    });
  }

  /**
   * Revoke a platform-admin billing grant
   */
  public static revokeBillingGrant<ThrowOnError extends boolean = true>(
    options: Options<RevokeBillingGrantData, ThrowOnError>,
  ): RequestResult<RevokeBillingGrantResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RevokeBillingGrantResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant',
      ...options,
    });
  }

  /**
   * Create or replace a platform-admin billing grant
   */
  public static upsertBillingGrant<ThrowOnError extends boolean = true>(
    options: Options<UpsertBillingGrantData, ThrowOnError>,
  ): RequestResult<UpsertBillingGrantResponses, unknown, ThrowOnError> {
    return (options.client ?? client).put<
      UpsertBillingGrantResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class ProfilesApi {
  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create6Data, ThrowOnError>,
  ): RequestResult<Create6Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create6Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static findByUserAndWorkspace<ThrowOnError extends boolean = true>(
    options: Options<FindByUserAndWorkspaceData, ThrowOnError>,
  ): RequestResult<FindByUserAndWorkspaceResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindByUserAndWorkspaceResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/user/{userId}/workspace/{workspaceId}',
      ...options,
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove7Data, ThrowOnError>,
  ): RequestResult<Remove7Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove7Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne5Data, ThrowOnError>,
  ): RequestResult<FindOne5Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne5Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update7Data, ThrowOnError>,
  ): RequestResult<Update7Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update7Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static resyncTemplate<ThrowOnError extends boolean = true>(
    options: Options<ResyncTemplateData, ThrowOnError>,
  ): RequestResult<ResyncTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ResyncTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}/resync-template',
      ...options,
    });
  }

  public static downloadWalletPass<ThrowOnError extends boolean = true>(
    options: Options<DownloadWalletPassData, ThrowOnError>,
  ): RequestResult<DownloadWalletPassResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      DownloadWalletPassResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'blob',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}/wallet-pass',
      ...options,
    });
  }

  public static getWalletCardStatus<ThrowOnError extends boolean = true>(
    options: Options<GetWalletCardStatusData, ThrowOnError>,
  ): RequestResult<GetWalletCardStatusResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetWalletCardStatusResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/profiles/{id}/wallet-card',
      ...options,
    });
  }

  public static getUsage<ThrowOnError extends boolean = true>(
    options: Options<GetUsageData, ThrowOnError>,
  ): RequestResult<GetUsageResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetUsageResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/profiles/{profileId}/usage',
      ...options,
    });
  }
}

export class ProfilesPublicApi {
  public static findByWorkspaceAndUsername<ThrowOnError extends boolean = true>(
    options: Options<FindByWorkspaceAndUsernameData, ThrowOnError>,
  ): RequestResult<FindByWorkspaceAndUsernameResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindByWorkspaceAndUsernameResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/profiles-public/workspace/{workspaceUsername}/username/{username}',
      ...options,
    });
  }

  public static findById<ThrowOnError extends boolean = true>(
    options: Options<FindByIdData, ThrowOnError>,
  ): RequestResult<FindByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindByIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/profiles-public/id/{id}',
      ...options,
    });
  }

  public static resolveByPublicHash<ThrowOnError extends boolean = true>(
    options: Options<ResolveByPublicHashData, ThrowOnError>,
  ): RequestResult<ResolveByPublicHashResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ResolveByPublicHashResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/profiles-public/hash/{hash}',
      ...options,
    });
  }

  public static findByWorkspaceIdAndUserId<ThrowOnError extends boolean = true>(
    options: Options<FindByWorkspaceIdAndUserIdData, ThrowOnError>,
  ): RequestResult<FindByWorkspaceIdAndUserIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindByWorkspaceIdAndUserIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/profiles-public/workspace/{workspaceId}/user/{userId}',
      ...options,
    });
  }

  public static recordDirectView<ThrowOnError extends boolean = true>(
    options: Options<RecordDirectViewData, ThrowOnError>,
  ): RequestResult<RecordDirectViewResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RecordDirectViewResponses,
      unknown,
      ThrowOnError
    >({ url: '/api/v1/profiles-public/id/{id}/view', ...options });
  }

  public static downloadContactVcf<ThrowOnError extends boolean = true>(
    options: Options<DownloadContactVcfData, ThrowOnError>,
  ): RequestResult<DownloadContactVcfResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      DownloadContactVcfResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'text',
      url: '/api/v1/profiles-public/id/{id}/contact.vcf',
      ...options,
    });
  }
}

export class ProductsApi {
  /**
   * Create (claim) a BLANK or unknown hash in this workspace
   */
  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create7Data, ThrowOnError>,
  ): RequestResult<Create7Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create7Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static createWithMail<ThrowOnError extends boolean = true>(
    options: Options<CreateWithMailData, ThrowOnError>,
  ): RequestResult<CreateWithMailResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateWithMailResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/with-mail',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List the workspace's claim requests (newest first)
   */
  public static listClaimRequests<ThrowOnError extends boolean = true>(
    options: Options<ListClaimRequestsData, ThrowOnError>,
  ): RequestResult<ListClaimRequestsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListClaimRequestsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-requests',
      ...options,
    });
  }

  /**
   * Count the workspace's pending claim requests (nav badge)
   */
  public static countClaimRequests<ThrowOnError extends boolean = true>(
    options: Options<CountClaimRequestsData, ThrowOnError>,
  ): RequestResult<CountClaimRequestsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      CountClaimRequestsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/count',
      ...options,
    });
  }

  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll7Data, ThrowOnError>,
  ): RequestResult<FindAll7Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll7Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/search',
      ...options,
    });
  }

  /**
   * Facet counts for products list filters (only values with count > 0)
   */
  public static findFacets<ThrowOnError extends boolean = true>(
    options: Options<FindFacetsData, ThrowOnError>,
  ): RequestResult<FindFacetsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindFacetsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/facets',
      ...options,
    });
  }

  /**
   * Product of this workspace by hash (404 hashNotExists)
   */
  public static findOneByHash<ThrowOnError extends boolean = true>(
    options: Options<FindOneByHashData, ThrowOnError>,
  ): RequestResult<FindOneByHashResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOneByHashResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/hash/{hash}',
      ...options,
    });
  }

  /**
   * What this workspace can do with a scanned hash (DEV-753)
   *
   * Server-side classification (setup, own product, teammate, other workspace, claim by e-mail, pending or manual). Unknown hashes are ready_for_setup. Replaces the client-side reading of the public view.
   */
  public static resolveProductHash<ThrowOnError extends boolean = true>(
    options: Options<ResolveProductHashData, ThrowOnError>,
  ): RequestResult<ResolveProductHashResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ResolveProductHashResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/hash/{hash}/resolution',
      ...options,
    });
  }

  /**
   * Remove link mapping from workspace (release: resets user-configured props)
   */
  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove8Data, ThrowOnError>,
  ): RequestResult<Remove8Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove8Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/{id}',
      ...options,
    });
  }

  /**
   * Product of this workspace by id (404 productNotFound)
   */
  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne6Data, ThrowOnError>,
  ): RequestResult<FindOne6Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne6Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/{id}',
      ...options,
    });
  }

  /**
   * Owner edit: target (as a unit), label, feedback funnel
   */
  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update8Data, ThrowOnError>,
  ): RequestResult<Update8Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update8Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Daily scans of a product of this workspace
   *
   * `days` whole UTC days ending today (today live), zero-filled, from the daily rollup plus today's raw scans (DEV-715). Cut to the plan's `quota.analytics_history_days` (`historyLimitedTo`, DEV-720).
   */
  public static findScans<ThrowOnError extends boolean = true>(
    options: Options<FindScansData, ThrowOnError>,
  ): RequestResult<FindScansResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindScansResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/{id}/scans',
      ...options,
    });
  }

  /**
   * Request to claim a product by hash
   *
   * Stateful claim (DEV-739): sends a single-use verification link (24 h) to the setup e-mail. Asking again while a request is pending re-sends it (60 s cooldown, limited resends). Without an e-mail on file: 422 claimRequiresManualVerification (use claim-request/manual). Requires products:manage.
   */
  public static claimRequest<ThrowOnError extends boolean = true>(
    options: Options<ClaimRequestData, ThrowOnError>,
  ): RequestResult<ClaimRequestResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ClaimRequestResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-request',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Request a manual claim (reviewed by the up2promo team)
   *
   * For products without a setup e-mail, or when the contact cannot be reached. No mail is sent; a platform admin approves or rejects it. Requires products:manage.
   */
  public static claimRequestManual<ThrowOnError extends boolean = true>(
    options: Options<ClaimRequestManualData, ThrowOnError>,
  ): RequestResult<ClaimRequestManualResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ClaimRequestManualResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-request/manual',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Re-send the verification mail of a pending EMAIL claim
   *
   * Rotates the token (the previous link stops working) and restarts the 24 h expiry. 429 claimResendCooldown / claimResendLimit. Requires products:manage.
   */
  public static resendClaimRequest<ThrowOnError extends boolean = true>(
    options: Options<ResendClaimRequestData, ThrowOnError>,
  ): RequestResult<ResendClaimRequestResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ResendClaimRequestResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/{requestId}/resend',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Cancel a pending claim request
   *
   * Requires products:manage.
   */
  public static cancelClaimRequest<ThrowOnError extends boolean = true>(
    options: Options<CancelClaimRequestData, ThrowOnError>,
  ): RequestResult<CancelClaimRequestResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CancelClaimRequestResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/{requestId}/cancel',
      ...options,
    });
  }

  /**
   * Reads raw scan events, kept for 395 days (13 months): a `startTime` further back is moved forward to that limit, or to the first day of the plan's `quota.analytics_history_days` when that is later.
   */
  public static summarizeEventsByMetadataField<
    ThrowOnError extends boolean = true,
  >(
    options: Options<SummarizeEventsByMetadataFieldData, ThrowOnError>,
  ): RequestResult<
    SummarizeEventsByMetadataFieldResponses,
    unknown,
    ThrowOnError
  > {
    return (options.client ?? client).post<
      SummarizeEventsByMetadataFieldResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/usage/summarize',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Reads raw scan events, kept for 395 days (13 months): a `startTime` further back is moved forward to that limit, or to the first day of the plan's `quota.analytics_history_days` when that is later.
   */
  public static findTopUsed<ThrowOnError extends boolean = true>(
    options: Options<FindTopUsedData, ThrowOnError>,
  ): RequestResult<FindTopUsedResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      FindTopUsedResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/usage/top-used',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Most recently scanned products: one row per hash (`_id` = `hash`) with its latest scan (`timestamp`) and the scans kept for it (`count`) within the plan `quota.analytics_history_days`, newest first. `filter` matches the hash. Body `startTime` / `endTime` are ignored.
   */
  public static findRecentScans<ThrowOnError extends boolean = true>(
    options: Options<FindRecentScansData, ThrowOnError>,
  ): RequestResult<FindRecentScansResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      FindRecentScansResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/usage/recent-scans',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Reads raw scan events, kept for 395 days (13 months): a `startTime` further back is moved forward to that limit, or to the first day of the plan's `quota.analytics_history_days` when that is later.
   */
  public static findUsageTimeSeries<ThrowOnError extends boolean = true>(
    options: Options<FindUsageTimeSeriesData, ThrowOnError>,
  ): RequestResult<FindUsageTimeSeriesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      FindUsageTimeSeriesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/usage/time-series',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Product history of this workspace (newest first, cursor paged)
   */
  public static listProductEvents<ThrowOnError extends boolean = true>(
    options: Options<ListProductEventsData, ThrowOnError>,
  ): RequestResult<ListProductEventsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListProductEventsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products/workspaces/{workspaceId}/{id}/events',
      ...options,
    });
  }
}

export class ProductsPublicApi {
  /**
   * Public product view (no setup contact, label or orders)
   */
  public static findOneByHashOnly<ThrowOnError extends boolean = true>(
    options: Options<FindOneByHashOnlyData, ThrowOnError>,
  ): RequestResult<FindOneByHashOnlyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOneByHashOnlyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/products-public/hash/{hash}',
      ...options,
    });
  }

  /**
   * Resolve the redirect of a hash and record a scan
   */
  public static resolveTargetUrl<ThrowOnError extends boolean = true>(
    options: Options<ResolveTargetUrlData, ThrowOnError>,
  ): RequestResult<ResolveTargetUrlResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ResolveTargetUrlResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/products-public/hash/{hash}/resolve',
      ...options,
    });
  }

  /**
   * Public setup: configure a blank hash with a URL target
   *
   * BLANK or unknown hash → CONFIGURED_UNOWNED. With `contact`, the reset code is mailed to it and the product can later be claimed by e-mail. 422 hashAlreadyExists when configured or claimed. Replaces `setup` + `setup/with-mail` of the pre-v2 contract.
   */
  public static setupProduct<ThrowOnError extends boolean = true>(
    options: Options<SetupProductData, ThrowOnError>,
  ): RequestResult<SetupProductResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SetupProductResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/products-public/setup',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Verify reset code and release product
   */
  public static verifyAndDeleteResetCode<ThrowOnError extends boolean = true>(
    options: Options<VerifyAndDeleteResetCodeData, ThrowOnError>,
  ): RequestResult<VerifyAndDeleteResetCodeResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      VerifyAndDeleteResetCodeResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/products-public/reset/{resetCode}',
      ...options,
    });
  }

  /**
   * Verify claim token and assign product to workspace
   *
   * Single-use link from the verification email (DEV-739). Assigns the product to the requesting workspace if it still has the setup the request was issued for; the configured redirect is kept. 422 errors.token: claimInvalid | claimExpired | claimSuperseded, errors.hash: alreadyClaimed.
   */
  public static claimVerify<ThrowOnError extends boolean = true>(
    options: Options<ClaimVerifyData, ThrowOnError>,
  ): RequestResult<ClaimVerifyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ClaimVerifyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/products-public/claim/verify',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class ProductsAdminApi {
  /**
   * Full product history (admin, newest first, cursor paged)
   */
  public static listProductEventsAdmin<ThrowOnError extends boolean = true>(
    options: Options<ListProductEventsAdminData, ThrowOnError>,
  ): RequestResult<ListProductEventsAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListProductEventsAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}/events',
      ...options,
    });
  }

  /**
   * Packing station: record the order on every packed hash (idempotent per hash and order)
   */
  public static packProducts<ThrowOnError extends boolean = true>(
    options: Options<PackProductsData, ThrowOnError>,
  ): RequestResult<PackProductsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      PackProductsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/pack',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Products carrying an order number (newest first, max 200)
   */
  public static searchProductsByOrder<ThrowOnError extends boolean = true>(
    options: Options<SearchProductsByOrderData, ThrowOnError>,
  ): RequestResult<SearchProductsByOrderResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      SearchProductsByOrderResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/search',
      ...options,
    });
  }

  /**
   * Recent scans of any product, newest first (live feed backfill)
   *
   * From stored scans: product fields are current, outcome and location are null (never stored).
   */
  public static findRecentLiveScansAdmin<ThrowOnError extends boolean = true>(
    options?: Options<FindRecentLiveScansAdminData, ThrowOnError>,
  ): RequestResult<FindRecentLiveScansAdminResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindRecentLiveScansAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/live-scans/recent',
      ...options,
    });
  }

  /**
   * Live scan stream (SSE, platform admins)
   *
   * Server-sent `data:` lines, each an `AdminLiveScanDto` JSON. Bearer auth; use fetch() with an Authorization header in browsers.
   */
  public static streamLiveScansAdmin<ThrowOnError extends boolean = true>(
    options?: Options<StreamLiveScansAdminData, ThrowOnError>,
  ): RequestResult<StreamLiveScansAdminResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      StreamLiveScansAdminResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/live-scans/stream',
      ...options,
    });
  }

  /**
   * Pending MANUAL claim requests (admin sidebar badge)
   */
  public static adminCountClaimRequests<ThrowOnError extends boolean = true>(
    options?: Options<AdminCountClaimRequestsData, ThrowOnError>,
  ): RequestResult<AdminCountClaimRequestsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      AdminCountClaimRequestsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/claim-requests/count',
      ...options,
    });
  }

  /**
   * Inspect a product by hash (ops toolkit)
   *
   * Full admin product view plus labeled workspace/profile/location refs and the live resolved target URL. Does not record a scan.
   */
  public static inspectByHashAdmin<ThrowOnError extends boolean = true>(
    options: Options<InspectByHashAdminData, ThrowOnError>,
  ): RequestResult<InspectByHashAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      InspectByHashAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/hash/{hash}/inspect',
      ...options,
    });
  }

  /**
   * List products across all workspaces (admin)
   *
   * Every filter, server-side sort and optional page-scoped scan counts (any owner). Never returns the setup contact address.
   */
  public static findAllAdmin<ThrowOnError extends boolean = true>(
    options?: Options<FindAllAdminData, ThrowOnError>,
  ): RequestResult<FindAllAdminResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindAllAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin',
      ...options,
    });
  }

  /**
   * Facet counts over the admin list filters (count > 0 only)
   */
  public static findFacetsAdmin<ThrowOnError extends boolean = true>(
    options?: Options<FindFacetsAdminData, ThrowOnError>,
  ): RequestResult<FindFacetsAdminResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindFacetsAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/facets',
      ...options,
    });
  }

  /**
   * KPI totals by state, stage and behaviour, plus 30-day scans
   */
  public static findStatsAdmin<ThrowOnError extends boolean = true>(
    options?: Options<FindStatsAdminData, ThrowOnError>,
  ): RequestResult<FindStatsAdminResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindStatsAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/stats',
      ...options,
    });
  }

  /**
   * Create a product (admin)
   *
   * With workspaceId: CLAIMED by it (validated like a member create, no entitlement check). Without: a URL setup (CONFIGURED_UNOWNED); `contact` receives the reset code. BLANK or unknown hashes only.
   */
  public static createAdmin<ThrowOnError extends boolean = true>(
    options: Options<CreateAdminData, ThrowOnError>,
  ): RequestResult<CreateAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/create',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Bulk-register minted hashes as BLANK + GENERATED (manufacturing)
   *
   * Called by admin manufacturing after QR/order-pack generation. Soft: configured, claimed or PROGRAMMED hashes are reported in failed[] without aborting the batch.
   */
  public static registerBatchAdmin<ThrowOnError extends boolean = true>(
    options: Options<RegisterBatchAdminData, ThrowOnError>,
  ): RequestResult<RegisterBatchAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RegisterBatchAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/register-batch',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Register a physical product from its public URL (goods receipt)
   *
   * Ops fallback when manufacturing bulk-register was skipped. Sets GENERATED only. Prefer POST register-batch after QR generation.
   */
  public static registerGoodsReceiptAdmin<ThrowOnError extends boolean = true>(
    options: Options<RegisterGoodsReceiptAdminData, ThrowOnError>,
  ): RequestResult<RegisterGoodsReceiptAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RegisterGoodsReceiptAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/register-goods-receipt',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Mark a hash as NFC-programmed (ops toolkit only)
   *
   * After a successful NFC write. Requires a registered GENERATED product. Refuses already-PROGRAMMED hashes; reset to GENERATED first.
   */
  public static markProgrammedAdmin<ThrowOnError extends boolean = true>(
    options: Options<MarkProgrammedAdminData, ThrowOnError>,
  ): RequestResult<MarkProgrammedAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      MarkProgrammedAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/hash/{hash}/mark-programmed',
      ...options,
    });
  }

  /**
   * Return a hash to GENERATED after NFC reset (ops toolkit)
   *
   * Called by the toolkit reset tool after wiping the chip. Does not change ownership or physical identity.
   */
  public static markGeneratedAdmin<ThrowOnError extends boolean = true>(
    options: Options<MarkGeneratedAdminData, ThrowOnError>,
  ): RequestResult<MarkGeneratedAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      MarkGeneratedAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/hash/{hash}/mark-generated',
      ...options,
    });
  }

  /**
   * Remove or release link mapping by id (admin, any workspace)
   */
  public static removeAdmin<ThrowOnError extends boolean = true>(
    options: Options<RemoveAdminData, ThrowOnError>,
  ): RequestResult<RemoveAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RemoveAdminResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}',
      ...options,
    });
  }

  /**
   * A product by id, any state and owner (admin)
   */
  public static findOneAdmin<ThrowOnError extends boolean = true>(
    options: Options<FindOneAdminData, ThrowOnError>,
  ): RequestResult<FindOneAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOneAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}',
      ...options,
    });
  }

  /**
   * Update a product by id (admin, any workspace)
   */
  public static updateAdmin<ThrowOnError extends boolean = true>(
    options: Options<UpdateAdminData, ThrowOnError>,
  ): RequestResult<UpdateAdminResponses, UpdateAdminErrors, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateAdminResponses,
      UpdateAdminErrors,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Claim requests for review (default: pending MANUAL, oldest first)
   *
   * At most 100 rows. `resolved=true`: the decided ones, newest first. `productId`: one product, any status and method. Rows carry the product, workspace name, requester, deciding admin and internal reject fields.
   */
  public static adminListClaimRequests<ThrowOnError extends boolean = true>(
    options?: Options<AdminListClaimRequestsData, ThrowOnError>,
  ): RequestResult<AdminListClaimRequestsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      AdminListClaimRequestsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/claim-requests',
      ...options,
    });
  }

  /**
   * Approve a MANUAL claim request
   *
   * Assigns the product to the requesting workspace (target and label kept) if it still has the setup the request was made for; other pending requests are superseded. The requester gets an e-mail.
   */
  public static approveClaimRequest<ThrowOnError extends boolean = true>(
    options: Options<ApproveClaimRequestData, ThrowOnError>,
  ): RequestResult<ApproveClaimRequestResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ApproveClaimRequestResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/claim-requests/{requestId}/approve',
      ...options,
    });
  }

  /**
   * Reject a MANUAL claim request
   *
   * The reason is customer-visible: the requesting workspace sees it as `rejectionReason` and the requester gets it by e-mail. `code` and `comment` are internal.
   */
  public static rejectClaimRequest<ThrowOnError extends boolean = true>(
    options: Options<RejectClaimRequestData, ThrowOnError>,
  ): RequestResult<RejectClaimRequestResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      RejectClaimRequestResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/claim-requests/{requestId}/reject',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Admin: remove or release link mapping by hash
   *
   * Works for unassigned (no workspace) and assigned mappings. Used by admin packing station when re-programming a QR that already exists.
   */
  public static deleteByHashAdmin<ThrowOnError extends boolean = true>(
    options: Options<DeleteByHashAdminData, ThrowOnError>,
  ): RequestResult<DeleteByHashAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      DeleteByHashAdminResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/hash/{hash}',
      ...options,
    });
  }

  /**
   * Daily scans of a product, whoever owns it (admin)
   *
   * By hash, without a workspace scope, so unowned products count too. Scans are deleted on release and move.
   */
  public static findScansAdmin<ThrowOnError extends boolean = true>(
    options: Options<FindScansAdminData, ThrowOnError>,
  ): RequestResult<FindScansAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindScansAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}/scans',
      ...options,
    });
  }

  /**
   * Reveal the setup contact of an unowned product (audited)
   *
   * Writes the platform event SETUP_CONTACT_VIEWED with the admin as actor. 404 setupNotFound when the product has no setup (BLANK or CLAIMED).
   */
  public static revealSetupContactAdmin<ThrowOnError extends boolean = true>(
    options: Options<RevealSetupContactAdminData, ThrowOnError>,
  ): RequestResult<RevealSetupContactAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      RevealSetupContactAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}/setup-contact',
      ...options,
    });
  }

  /**
   * Assign a BLANK or unowned product to a workspace (admin)
   *
   * CLAIMED via ADMIN_ASSIGN; a configured target and label are kept, the setup contact is cleared and pending claim requests are superseded. 422 alreadyClaimed on a CLAIMED product (use move).
   */
  public static assignAdmin<ThrowOnError extends boolean = true>(
    options: Options<AssignAdminData, ThrowOnError>,
  ): RequestResult<AssignAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      AssignAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}/assign',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Move a CLAIMED product to another workspace (admin)
   *
   * Release + assign in one write: target, label and feedback are reset and the scans deleted; item, orders and history are kept. Events RELEASED + CLAIMED. 422 productNotClaimed / moveSameWorkspace.
   */
  public static moveAdmin<ThrowOnError extends boolean = true>(
    options: Options<MoveAdminData, ThrowOnError>,
  ): RequestResult<MoveAdminResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      MoveAdminResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/products-admin/{id}/move',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class LocationsApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll8Data, ThrowOnError>,
  ): RequestResult<FindAll8Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll8Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create8Data, ThrowOnError>,
  ): RequestResult<Create8Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create8Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getReplyPromptTemplates<ThrowOnError extends boolean = true>(
    options?: Options<GetReplyPromptTemplatesData, ThrowOnError>,
  ): RequestResult<GetReplyPromptTemplatesResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetReplyPromptTemplatesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/reply-prompt-templates',
      ...options,
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove9Data, ThrowOnError>,
  ): RequestResult<Remove9Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove9Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{id}',
      ...options,
    });
  }

  public static findById<ThrowOnError extends boolean = true>(
    options: Options<FindById2Data, ThrowOnError>,
  ): RequestResult<FindById2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindById2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{id}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update9Data, ThrowOnError>,
  ): RequestResult<Update9Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update9Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class LocationsPublicApi {
  /**
   * Search Google Places (public)
   *
   * No authentication required. Used by setup and other clients without a workspace context.
   */
  public static searchGooglePlaces<ThrowOnError extends boolean = true>(
    options: Options<SearchGooglePlacesData, ThrowOnError>,
  ): RequestResult<SearchGooglePlacesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      SearchGooglePlacesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/locations-public/google-places/search',
      ...options,
    });
  }

  /**
   * Get Google Place by ID (public)
   *
   * Place Details by Place ID — no text search. Used when the Place ID is already known (e.g. picked in the storefront autocomplete).
   */
  public static getGooglePlaceById<ThrowOnError extends boolean = true>(
    options: Options<GetGooglePlaceByIdData, ThrowOnError>,
  ): RequestResult<GetGooglePlaceByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetGooglePlaceByIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/locations-public/google-places/{placeId}',
      ...options,
    });
  }
}

export class AdminLocationsApi {
  /**
   * Search a workspace's locations (platform admin)
   */
  public static searchAdminLocations<ThrowOnError extends boolean = true>(
    options: Options<SearchAdminLocationsData, ThrowOnError>,
  ): RequestResult<SearchAdminLocationsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      SearchAdminLocationsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/admin/locations/search',
      ...options,
    });
  }
}

export class LeadsApi {
  public static find<ThrowOnError extends boolean = true>(
    options: Options<FindData, ThrowOnError>,
  ): RequestResult<FindResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<FindResponses, unknown, ThrowOnError>(
      {
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/workspaces/{workspaceId}/leads',
        ...options,
      },
    );
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create9Data, ThrowOnError>,
  ): RequestResult<Create9Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create9Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static scanBusinessCard<ThrowOnError extends boolean = true>(
    options: Options<ScanBusinessCardData, ThrowOnError>,
  ): RequestResult<ScanBusinessCardResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ScanBusinessCardResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/scan-business-card',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static exchangeBusinessCard<ThrowOnError extends boolean = true>(
    options: Options<ExchangeBusinessCardData, ThrowOnError>,
  ): RequestResult<ExchangeBusinessCardResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ExchangeBusinessCardResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/exchange-business-card',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static bulkUpdate<ThrowOnError extends boolean = true>(
    options: Options<BulkUpdateData, ThrowOnError>,
  ): RequestResult<BulkUpdateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      BulkUpdateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/bulk',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove10Data, ThrowOnError>,
  ): RequestResult<Remove10Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove10Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne7Data, ThrowOnError>,
  ): RequestResult<FindOne7Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne7Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update10Data, ThrowOnError>,
  ): RequestResult<Update10Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update10Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static contactVia<ThrowOnError extends boolean = true>(
    options: Options<ContactViaData, ThrowOnError>,
  ): RequestResult<ContactViaResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ContactViaResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/contact',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static addNote<ThrowOnError extends boolean = true>(
    options: Options<AddNoteData, ThrowOnError>,
  ): RequestResult<AddNoteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      AddNoteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static removeNote<ThrowOnError extends boolean = true>(
    options: Options<RemoveNoteData, ThrowOnError>,
  ): RequestResult<RemoveNoteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RemoveNoteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes/{noteId}',
      ...options,
    });
  }

  public static updateNote<ThrowOnError extends boolean = true>(
    options: Options<UpdateNoteData, ThrowOnError>,
  ): RequestResult<UpdateNoteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateNoteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes/{noteId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static addAttachment<ThrowOnError extends boolean = true>(
    options: Options<AddAttachmentData, ThrowOnError>,
  ): RequestResult<AddAttachmentResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      AddAttachmentResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static reorderAttachments<ThrowOnError extends boolean = true>(
    options: Options<ReorderAttachmentsData, ThrowOnError>,
  ): RequestResult<ReorderAttachmentsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      ReorderAttachmentsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments/reorder',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static removeAttachment<ThrowOnError extends boolean = true>(
    options: Options<RemoveAttachmentData, ThrowOnError>,
  ): RequestResult<RemoveAttachmentResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      RemoveAttachmentResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments/{attachmentId}',
      ...options,
    });
  }
}

export class LeadsPublicApi {
  public static submitLeadForm<ThrowOnError extends boolean = true>(
    options: Options<SubmitLeadFormData, ThrowOnError>,
  ): RequestResult<SubmitLeadFormResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SubmitLeadFormResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/public/profiles/{profileId}/leads',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class LeadEventsApi {
  public static findAll<ThrowOnError extends boolean = true>(
    options: Options<FindAll9Data, ThrowOnError>,
  ): RequestResult<FindAll9Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindAll9Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events',
      ...options,
    });
  }

  public static create<ThrowOnError extends boolean = true>(
    options: Options<Create10Data, ThrowOnError>,
  ): RequestResult<Create10Responses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      Create10Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static resolveRoster<ThrowOnError extends boolean = true>(
    options: Options<ResolveRosterData, ThrowOnError>,
  ): RequestResult<ResolveRosterResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ResolveRosterResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/roster/resolved',
      ...options,
    });
  }

  public static findLeads<ThrowOnError extends boolean = true>(
    options: Options<FindLeadsData, ThrowOnError>,
  ): RequestResult<FindLeadsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindLeadsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/leads',
      ...options,
    });
  }

  public static getEventAnalytics<ThrowOnError extends boolean = true>(
    options: Options<GetEventAnalyticsData, ThrowOnError>,
  ): RequestResult<GetEventAnalyticsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetEventAnalyticsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/analytics',
      ...options,
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove11Data, ThrowOnError>,
  ): RequestResult<Remove11Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove11Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}',
      ...options,
    });
  }

  public static findOne<ThrowOnError extends boolean = true>(
    options: Options<FindOne8Data, ThrowOnError>,
  ): RequestResult<FindOne8Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindOne8Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}',
      ...options,
    });
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update11Data, ThrowOnError>,
  ): RequestResult<Update11Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update11Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static updateRoster<ThrowOnError extends boolean = true>(
    options: Options<UpdateRosterData, ThrowOnError>,
  ): RequestResult<UpdateRosterResponses, unknown, ThrowOnError> {
    return (options.client ?? client).put<
      UpdateRosterResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/roster',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class HomeApi {
  public static appInfo<ThrowOnError extends boolean = true>(
    options?: Options<AppInfoData, ThrowOnError>,
  ): RequestResult<AppInfoResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      AppInfoResponses,
      unknown,
      ThrowOnError
    >({ url: '/', ...options });
  }
}

export class StatusBoardApi {
  public static getBoard<ThrowOnError extends boolean = true>(
    options: Options<GetBoardData, ThrowOnError>,
  ): RequestResult<GetBoardResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetBoardResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/status-board',
      ...options,
    });
  }
}

export class ReviewsApi {
  public static listReviews<ThrowOnError extends boolean = true>(
    options: Options<ListReviewsData, ThrowOnError>,
  ): RequestResult<ListReviewsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListReviewsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews',
      ...options,
    });
  }

  public static suggestReply<ThrowOnError extends boolean = true>(
    options: Options<SuggestReplyData, ThrowOnError>,
  ): RequestResult<SuggestReplyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SuggestReplyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/suggest-reply',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static suggestReplyPreview<ThrowOnError extends boolean = true>(
    options: Options<SuggestReplyPreviewData, ThrowOnError>,
  ): RequestResult<SuggestReplyPreviewResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SuggestReplyPreviewResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/suggest-reply-preview',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static createBulkReplyDrafts<ThrowOnError extends boolean = true>(
    options: Options<CreateBulkReplyDraftsData, ThrowOnError>,
  ): RequestResult<CreateBulkReplyDraftsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateBulkReplyDraftsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/reply-drafts/bulk',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Poll bulk AI reply draft batch status
   */
  public static getBulkReplyDraftBatch<ThrowOnError extends boolean = true>(
    options: Options<GetBulkReplyDraftBatchData, ThrowOnError>,
  ): RequestResult<GetBulkReplyDraftBatchResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetBulkReplyDraftBatchResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/reply-drafts/bulk/{batchId}',
      ...options,
    });
  }

  public static createReplyDraft<ThrowOnError extends boolean = true>(
    options: Options<CreateReplyDraftData, ThrowOnError>,
  ): RequestResult<CreateReplyDraftResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateReplyDraftResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply-drafts',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static publishReplyDraft<ThrowOnError extends boolean = true>(
    options: Options<PublishReplyDraftData, ThrowOnError>,
  ): RequestResult<PublishReplyDraftResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      PublishReplyDraftResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply-drafts/{draftId}/publish',
      ...options,
    });
  }

  public static deleteReply<ThrowOnError extends boolean = true>(
    options: Options<DeleteReplyData, ThrowOnError>,
  ): RequestResult<DeleteReplyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      DeleteReplyResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply',
      ...options,
    });
  }

  public static getReply<ThrowOnError extends boolean = true>(
    options: Options<GetReplyData, ThrowOnError>,
  ): RequestResult<GetReplyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetReplyResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply',
      ...options,
    });
  }
}

export class ReputationApi {
  public static getPresets<ThrowOnError extends boolean = true>(
    options?: Options<GetPresetsData, ThrowOnError>,
  ): RequestResult<GetPresetsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      GetPresetsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/presets',
      ...options,
    });
  }

  public static getOverview<ThrowOnError extends boolean = true>(
    options: Options<GetOverviewData, ThrowOnError>,
  ): RequestResult<GetOverviewResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetOverviewResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/overview',
      ...options,
    });
  }

  public static getSummary<ThrowOnError extends boolean = true>(
    options: Options<GetSummaryData, ThrowOnError>,
  ): RequestResult<GetSummaryResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetSummaryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/summary',
      ...options,
    });
  }

  public static getDrivers<ThrowOnError extends boolean = true>(
    options: Options<GetDriversData, ThrowOnError>,
  ): RequestResult<GetDriversResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetDriversResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/drivers',
      ...options,
    });
  }

  public static getAnalytics<ThrowOnError extends boolean = true>(
    options: Options<GetAnalyticsData, ThrowOnError>,
  ): RequestResult<GetAnalyticsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetAnalyticsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/analytics',
      ...options,
    });
  }

  public static listWorkspaceReviews<ThrowOnError extends boolean = true>(
    options: Options<ListWorkspaceReviewsData, ThrowOnError>,
  ): RequestResult<ListWorkspaceReviewsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListWorkspaceReviewsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/reviews',
      ...options,
    });
  }

  /**
   * Mark reviews as seen
   *
   * Clears unseen attention for the workspace inbox. Omit reviewIds to mark all unseen reviews.
   */
  public static markReviewsSeen<ThrowOnError extends boolean = true>(
    options: Options<MarkReviewsSeenData, ThrowOnError>,
  ): RequestResult<MarkReviewsSeenResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      MarkReviewsSeenResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/reviews/mark-seen',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getCompetitors<ThrowOnError extends boolean = true>(
    options: Options<GetCompetitorsData, ThrowOnError>,
  ): RequestResult<GetCompetitorsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetCompetitorsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/competitors',
      ...options,
    });
  }

  public static getChannelLocations<ThrowOnError extends boolean = true>(
    options: Options<GetChannelLocationsData, ThrowOnError>,
  ): RequestResult<GetChannelLocationsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetChannelLocationsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/reputation/channel-locations',
      ...options,
    });
  }
}

export class IntegrationsApi {
  public static list<ThrowOnError extends boolean = true>(
    options: Options<ListData, ThrowOnError>,
  ): RequestResult<ListResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<ListResponses, unknown, ThrowOnError>(
      {
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/workspaces/{workspaceId}/integrations',
        ...options,
      },
    );
  }

  public static getConnectUrl<ThrowOnError extends boolean = true>(
    options: Options<GetConnectUrlData, ThrowOnError>,
  ): RequestResult<GetConnectUrlResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetConnectUrlResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/integrations/google/connect-url',
      ...options,
    });
  }

  public static disconnect<ThrowOnError extends boolean = true>(
    options: Options<DisconnectData, ThrowOnError>,
  ): RequestResult<DisconnectResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      DisconnectResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/integrations/google',
      ...options,
    });
  }

  public static getStatus<ThrowOnError extends boolean = true>(
    options: Options<GetStatusData, ThrowOnError>,
  ): RequestResult<GetStatusResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetStatusResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/integrations/google',
      ...options,
    });
  }

  public static listLocations<ThrowOnError extends boolean = true>(
    options: Options<ListLocationsData, ThrowOnError>,
  ): RequestResult<ListLocationsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListLocationsResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/integrations/google/locations',
      ...options,
    });
  }

  public static callback<ThrowOnError extends boolean = true>(
    options: Options<CallbackData, ThrowOnError>,
  ): RequestResult<unknown, unknown, ThrowOnError> {
    return (options.client ?? client).get<unknown, unknown, ThrowOnError>({
      url: '/api/v1/integrations/google/callback',
      ...options,
    });
  }

  public static unlink<ThrowOnError extends boolean = true>(
    options: Options<UnlinkData, ThrowOnError>,
  ): RequestResult<UnlinkResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      UnlinkResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/link',
      ...options,
    });
  }

  public static link<ThrowOnError extends boolean = true>(
    options: Options<LinkData, ThrowOnError>,
  ): RequestResult<LinkResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      LinkResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/link',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static clearSkip<ThrowOnError extends boolean = true>(
    options: Options<ClearSkipData, ThrowOnError>,
  ): RequestResult<ClearSkipResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      ClearSkipResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/skip',
      ...options,
    });
  }

  public static skip<ThrowOnError extends boolean = true>(
    options: Options<SkipData, ThrowOnError>,
  ): RequestResult<SkipResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SkipResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/skip',
      ...options,
    });
  }
}

export class CompetitorsApi {
  public static list<ThrowOnError extends boolean = true>(
    options: Options<List2Data, ThrowOnError>,
  ): RequestResult<List2Responses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      List2Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors',
      ...options,
    });
  }

  public static add<ThrowOnError extends boolean = true>(
    options: Options<AddData, ThrowOnError>,
  ): RequestResult<AddResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<AddResponses, unknown, ThrowOnError>(
      {
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors',
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
      },
    );
  }

  public static nearby<ThrowOnError extends boolean = true>(
    options: Options<NearbyData, ThrowOnError>,
  ): RequestResult<NearbyResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      NearbyResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/nearby',
      ...options,
    });
  }

  public static summary<ThrowOnError extends boolean = true>(
    options: Options<SummaryData, ThrowOnError>,
  ): RequestResult<SummaryResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      SummaryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/summary',
      ...options,
    });
  }

  public static remove<ThrowOnError extends boolean = true>(
    options: Options<Remove12Data, ThrowOnError>,
  ): RequestResult<Remove12Responses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      Remove12Responses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/{competitorId}',
      ...options,
    });
  }
}

export class FeedbackApi {
  public static listEntries<ThrowOnError extends boolean = true>(
    options: Options<ListEntriesData, ThrowOnError>,
  ): RequestResult<ListEntriesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListEntriesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/entries',
      ...options,
    });
  }

  public static getEntry<ThrowOnError extends boolean = true>(
    options: Options<GetEntryData, ThrowOnError>,
  ): RequestResult<GetEntryResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetEntryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/entries/{entryId}',
      ...options,
    });
  }

  public static patchEntry<ThrowOnError extends boolean = true>(
    options: Options<PatchEntryData, ThrowOnError>,
  ): RequestResult<PatchEntryResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      PatchEntryResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/entries/{entryId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getStats<ThrowOnError extends boolean = true>(
    options: Options<GetStatsData, ThrowOnError>,
  ): RequestResult<GetStatsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetStatsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/stats',
      ...options,
    });
  }

  public static listContacts<ThrowOnError extends boolean = true>(
    options: Options<ListContactsData, ThrowOnError>,
  ): RequestResult<ListContactsResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListContactsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/contacts',
      ...options,
    });
  }

  public static listFormTemplates<ThrowOnError extends boolean = true>(
    options: Options<ListFormTemplatesData, ThrowOnError>,
  ): RequestResult<ListFormTemplatesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListFormTemplatesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates',
      ...options,
    });
  }

  public static createFormTemplate<ThrowOnError extends boolean = true>(
    options: Options<CreateFormTemplateData, ThrowOnError>,
  ): RequestResult<CreateFormTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateFormTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteFormTemplate<ThrowOnError extends boolean = true>(
    options: Options<DeleteFormTemplateData, ThrowOnError>,
  ): RequestResult<DeleteFormTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      DeleteFormTemplateResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}',
      ...options,
    });
  }

  public static getFormTemplate<ThrowOnError extends boolean = true>(
    options: Options<GetFormTemplateData, ThrowOnError>,
  ): RequestResult<GetFormTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetFormTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}',
      ...options,
    });
  }

  public static updateFormTemplate<ThrowOnError extends boolean = true>(
    options: Options<UpdateFormTemplateData, ThrowOnError>,
  ): RequestResult<UpdateFormTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateFormTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static listMailTemplates<ThrowOnError extends boolean = true>(
    options: Options<ListMailTemplatesData, ThrowOnError>,
  ): RequestResult<ListMailTemplatesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListMailTemplatesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates',
      ...options,
    });
  }

  public static createMailTemplate<ThrowOnError extends boolean = true>(
    options: Options<CreateMailTemplateData, ThrowOnError>,
  ): RequestResult<CreateMailTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateMailTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static deleteMailTemplate<ThrowOnError extends boolean = true>(
    options: Options<DeleteMailTemplateData, ThrowOnError>,
  ): RequestResult<DeleteMailTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).delete<
      DeleteMailTemplateResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}',
      ...options,
    });
  }

  public static getMailTemplate<ThrowOnError extends boolean = true>(
    options: Options<GetMailTemplateData, ThrowOnError>,
  ): RequestResult<GetMailTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetMailTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}',
      ...options,
    });
  }

  public static updateMailTemplate<ThrowOnError extends boolean = true>(
    options: Options<UpdateMailTemplateData, ThrowOnError>,
  ): RequestResult<UpdateMailTemplateResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateMailTemplateResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static listInvites<ThrowOnError extends boolean = true>(
    options: Options<ListInvitesData, ThrowOnError>,
  ): RequestResult<ListInvitesResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ListInvitesResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites',
      ...options,
    });
  }

  public static createInvite<ThrowOnError extends boolean = true>(
    options: Options<CreateInviteData, ThrowOnError>,
  ): RequestResult<CreateInviteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CreateInviteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static sendPreviewMail<ThrowOnError extends boolean = true>(
    options: Options<SendPreviewMailData, ThrowOnError>,
  ): RequestResult<SendPreviewMailResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SendPreviewMailResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/preview',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static getInvite<ThrowOnError extends boolean = true>(
    options: Options<GetInviteData, ThrowOnError>,
  ): RequestResult<GetInviteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetInviteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}',
      ...options,
    });
  }

  public static updateInvite<ThrowOnError extends boolean = true>(
    options: Options<UpdateInviteData, ThrowOnError>,
  ): RequestResult<UpdateInviteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      UpdateInviteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static sendInvite<ThrowOnError extends boolean = true>(
    options: Options<SendInviteData, ThrowOnError>,
  ): RequestResult<SendInviteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SendInviteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/send',
      ...options,
    });
  }

  public static cancelInvite<ThrowOnError extends boolean = true>(
    options: Options<CancelInviteData, ThrowOnError>,
  ): RequestResult<CancelInviteResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      CancelInviteResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/cancel',
      ...options,
    });
  }

  public static resendInviteRecipient<ThrowOnError extends boolean = true>(
    options: Options<ResendInviteRecipientData, ThrowOnError>,
  ): RequestResult<ResendInviteRecipientResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ResendInviteRecipientResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/recipients/{recipientId}/resend',
      ...options,
    });
  }
}

export class FeedbackPublicApi {
  public static getByToken<ThrowOnError extends boolean = true>(
    options: Options<GetByTokenData, ThrowOnError>,
  ): RequestResult<GetByTokenResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetByTokenResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/public/feedback/tokens/{token}',
      ...options,
    });
  }

  public static submit<ThrowOnError extends boolean = true>(
    options: Options<SubmitData, ThrowOnError>,
  ): RequestResult<SubmitResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SubmitResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/public/feedback/tokens/{token}/submit',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static reviewCtaGet<ThrowOnError extends boolean = true>(
    options: Options<ReviewCtaGetData, ThrowOnError>,
  ): RequestResult<ReviewCtaGetResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ReviewCtaGetResponses,
      unknown,
      ThrowOnError
    >({ url: '/api/v1/public/feedback/tokens/{token}/review-cta', ...options });
  }

  public static reviewCtaPost<ThrowOnError extends boolean = true>(
    options: Options<ReviewCtaPostData, ThrowOnError>,
  ): RequestResult<ReviewCtaPostResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ReviewCtaPostResponses,
      unknown,
      ThrowOnError
    >({ url: '/api/v1/public/feedback/tokens/{token}/review-cta', ...options });
  }

  public static getProductFunnel<ThrowOnError extends boolean = true>(
    options: Options<GetProductFunnelData, ThrowOnError>,
  ): RequestResult<GetProductFunnelResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      GetProductFunnelResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/public/feedback/products/{hash}',
      ...options,
    });
  }

  public static submitProduct<ThrowOnError extends boolean = true>(
    options: Options<SubmitProductData, ThrowOnError>,
  ): RequestResult<SubmitProductResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SubmitProductResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      url: '/api/v1/public/feedback/products/{hash}/submit',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  public static productReviewCtaGet<ThrowOnError extends boolean = true>(
    options: Options<ProductReviewCtaGetData, ThrowOnError>,
  ): RequestResult<ProductReviewCtaGetResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      ProductReviewCtaGetResponses,
      unknown,
      ThrowOnError
    >({
      url: '/api/v1/public/feedback/products/{hash}/review-cta',
      ...options,
    });
  }

  public static productReviewCtaPost<ThrowOnError extends boolean = true>(
    options: Options<ProductReviewCtaPostData, ThrowOnError>,
  ): RequestResult<ProductReviewCtaPostResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ProductReviewCtaPostResponses,
      unknown,
      ThrowOnError
    >({
      url: '/api/v1/public/feedback/products/{hash}/review-cta',
      ...options,
    });
  }

  public static unsubscribe<ThrowOnError extends boolean = true>(
    options: Options<UnsubscribeData, ThrowOnError>,
  ): RequestResult<UnsubscribeResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      UnsubscribeResponses,
      unknown,
      ThrowOnError
    >({ url: '/api/v1/public/feedback/unsubscribe/{token}', ...options });
  }
}

export class GuidanceApi {
  public static get<ThrowOnError extends boolean = true>(
    options?: Options<GetData, ThrowOnError>,
  ): RequestResult<GetResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<GetResponses, unknown, ThrowOnError>(
      {
        responseType: 'json',
        security: [{ scheme: 'bearer', type: 'http' }],
        url: '/api/v1/users/me/guidance-progress',
        ...options,
      },
    );
  }

  public static update<ThrowOnError extends boolean = true>(
    options: Options<Update12Data, ThrowOnError>,
  ): RequestResult<Update12Responses, unknown, ThrowOnError> {
    return (options.client ?? client).patch<
      Update12Responses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/me/guidance-progress',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class BillbeeAdminApi {
  /**
   * List packable Billbee orders with stock allocation
   */
  public static findBillbeePackingStationOrders<
    ThrowOnError extends boolean = true,
  >(
    options?: Options<FindBillbeePackingStationOrdersData, ThrowOnError>,
  ): RequestResult<
    FindBillbeePackingStationOrdersResponses,
    unknown,
    ThrowOnError
  > {
    return (options?.client ?? client).get<
      FindBillbeePackingStationOrdersResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/packing-station/orders',
      ...options,
    });
  }

  /**
   * Search Billbee orders by term
   */
  public static searchBillbeeOrders<ThrowOnError extends boolean = true>(
    options: Options<SearchBillbeeOrdersData, ThrowOnError>,
  ): RequestResult<SearchBillbeeOrdersResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      SearchBillbeeOrdersResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/orders/search',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get a Billbee order by id
   */
  public static findBillbeeOrderById<ThrowOnError extends boolean = true>(
    options: Options<FindBillbeeOrderByIdData, ThrowOnError>,
  ): RequestResult<FindBillbeeOrderByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindBillbeeOrderByIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/orders/{orderId}',
      ...options,
    });
  }

  /**
   * Add a shipment and mark the Billbee order as shipped
   */
  public static shipBillbeeOrder<ThrowOnError extends boolean = true>(
    options: Options<ShipBillbeeOrderData, ThrowOnError>,
  ): RequestResult<ShipBillbeeOrderResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      ShipBillbeeOrderResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/orders/{orderId}/ship',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Get a Billbee customer address
   */
  public static findBillbeeAddressById<ThrowOnError extends boolean = true>(
    options: Options<FindBillbeeAddressByIdData, ThrowOnError>,
  ): RequestResult<FindBillbeeAddressByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      FindBillbeeAddressByIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/customer-addresses/{addressId}',
      ...options,
    });
  }

  /**
   * Update a Billbee customer address
   */
  public static updateBillbeeAddressById<ThrowOnError extends boolean = true>(
    options: Options<UpdateBillbeeAddressByIdData, ThrowOnError>,
  ): RequestResult<UpdateBillbeeAddressByIdResponses, unknown, ThrowOnError> {
    return (options.client ?? client).put<
      UpdateBillbeeAddressByIdResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/customer-addresses/{addressId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * List Billbee stock items
   */
  public static findBillbeeStockItems<ThrowOnError extends boolean = true>(
    options?: Options<FindBillbeeStockItemsData, ThrowOnError>,
  ): RequestResult<FindBillbeeStockItemsResponses, unknown, ThrowOnError> {
    return (options?.client ?? client).get<
      FindBillbeeStockItemsResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/stock',
      ...options,
    });
  }

  /**
   * Set the stock of one Billbee SKU
   */
  public static updateBillbeeStock<ThrowOnError extends boolean = true>(
    options: Options<UpdateBillbeeStockData, ThrowOnError>,
  ): RequestResult<UpdateBillbeeStockResponses, unknown, ThrowOnError> {
    return (options.client ?? client).put<
      UpdateBillbeeStockResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/stock',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }

  /**
   * Set the stock of several Billbee SKUs
   */
  public static updateBillbeeStockBulk<ThrowOnError extends boolean = true>(
    options: Options<UpdateBillbeeStockBulkData, ThrowOnError>,
  ): RequestResult<UpdateBillbeeStockBulkResponses, unknown, ThrowOnError> {
    return (options.client ?? client).post<
      UpdateBillbeeStockBulkResponses,
      unknown,
      ThrowOnError
    >({
      responseType: 'json',
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/billbee-admin/stock/bulk',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });
  }
}

export class RealtimeApi {
  /**
   * Workspace realtime event stream (SSE)
   *
   * Server-sent events for workspace-scoped realtime updates (e.g. product scans). Requires Bearer auth; use fetch() with Authorization header in browsers.
   */
  public static stream<ThrowOnError extends boolean = true>(
    options: Options<StreamData, ThrowOnError>,
  ): RequestResult<StreamResponses, unknown, ThrowOnError> {
    return (options.client ?? client).get<
      StreamResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/workspaces/{workspaceId}/realtime/stream',
      ...options,
    });
  }
}
